import { MAX_DATA_LAYER_FEATURES, MAX_DATA_LAYER_PAYLOAD_BYTES, PRO_DATA_LAYER_LIMITS, type DataLayerPayload } from './data-layer.js';
import { jsonByteLength } from './json-size.js';

export function cloudLayerLimits(pro: boolean) {
  return pro ? PRO_DATA_LAYER_LIMITS : { maxFeatures: MAX_DATA_LAYER_FEATURES, maxBytes: MAX_DATA_LAYER_PAYLOAD_BYTES };
}
export type CloudLayerLimitReason = 'features' | 'bytes' | 'source_file';
export class CloudLayerLimitError extends Error {
  constructor(readonly reason: CloudLayerLimitReason) {
    super('This layer exceeds the cloud save limit. Export the data to keep a portable copy.');
    this.name = 'CloudLayerLimitError';
  }
}
export function cloudLayerLimitReason(payload: DataLayerPayload, pro: boolean): CloudLayerLimitReason | null {
  const limits = cloudLayerLimits(pro);
  if (payload.features.length > limits.maxFeatures) return 'features';
  return jsonByteLength(payload, limits.maxBytes) > limits.maxBytes ? 'bytes' : null;
}
